import { AuthForm } from "../components/auth/AuthForm";

export function RegisterPage() {
  return <AuthForm mode="register" />;
}
